import { useQuery } from '@tanstack/react-query';
import { DepartmentSchema, type Department, type DepartmentListFilter } from '@magimp/shared';
import { useApiClient } from '../api/context.js';

const DepartmentsListResponseSchema = DepartmentSchema.array();

export function useDepartmentsList(filter: DepartmentListFilter = {}) {
  const client = useApiClient();
  return useQuery<Department[]>({
    queryKey: ['departments', 'list', filter],
    queryFn: ({ signal }) =>
      client.get<Department[]>(
        '/departments',
        {
          signal,
          query: filter as Record<string, string | number | boolean | null | undefined>,
        },
        DepartmentsListResponseSchema,
      ),
  });
}
